import React from 'react';

const NextArrow = (props) => <span className="slick-next" onClick={props.onClick}><i
    className="fa fa-angle-right"/></span>;

export default NextArrow;